import { Injectable, signal } from '@angular/core';

/**
 * Manages popup window state at a level above record detail components,
 * so the popup persists across record-to-record navigation.
 */
@Injectable({ providedIn: 'root' })
export class PopupWindowStateService {
  readonly visible = signal(false);
  readonly expanded = signal(false);
  readonly currentRecordId = signal('');
  readonly currentRecordLabel = signal<string | null>(null);
  readonly currentFragment = signal<string | null>(null);

  show(): void {
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }

  toggleExpanded(): void {
    this.expanded.update((v) => !v);
  }

  setExpanded(value: boolean): void {
    this.expanded.set(value);
  }

  setCurrentRecordId(recordId: string): void {
    this.currentRecordId.set(recordId);
    // Clear previous label when target changes to avoid stale mention text.
    this.currentRecordLabel.set(null);
  }

  setCurrentRecordLabel(label: string | null): void {
    this.currentRecordLabel.set(label);
  }

  setCurrentFragment(fragment: string | null): void {
    this.currentFragment.set(fragment);
  }

  reset(): void {
    this.visible.set(false);
    this.expanded.set(false);
    this.currentRecordId.set('');
    this.currentRecordLabel.set(null);
    this.currentFragment.set(null);
  }
}
